import filter from 'lodash/filter'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import reduce from 'lodash/reduce'

import { getVariantByCode } from 'shop/products/utils'

export const getUnavailableVariantIds = (products, variantCode) =>
  reduce(
    products,
    (acc, product) => {
      const { variants } = product
      if (!get(product, 'priceRange.minWholesaleValue')) {
        const variantValueIds = get(
          getVariantByCode(variants, variantCode),
          'values',
          [],
        ).map((value) => value.id)
        return [...acc, ...variantValueIds]
      }
      return acc
    },
    [],
  )

export const getAvailableDeliveryCollections = (collections = [], orderDate) =>
  isEmpty(orderDate)
    ? collections
    : filter(collections, (collection) => {
        const collectionStartDate = get(collection, 'delivery.startShipDate')
        return (
          new Date(orderDate).getTime() >=
            new Date(collectionStartDate).getTime() ||
          isEmpty(collectionStartDate)
        )
      })
